module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_06 (1).63d5f7e0.png";